// Whether a saved lead magnet widget is in use, and where it is embedded.
//
// Used means a visitor has run a scan with it. Leads still count: a widget that captured
// leads before scans were counted (migration 026 in the Report Management Service) has
// a scanCount of 0 but has plainly been used. Scans from Saved widgets' "Test this
// widget" are not counted by the server.
//
// last_used counts as well. The scan route has always set it on every scan request, so it
// is the only record of scans from before scanCount existed. It is a date, not a count,
// and may include a tenant's own test runs from that time; calling a live widget unused
// (and having it deleted off a customer's site) is the worse mistake.
export const isWidgetUsed = (w) =>
  Number(w?.scanCount) > 0 || Number(w?.leadCount) > 0 || !!w?.last_used;

// When a visitor last ran a scan with it. lastScanAt is exact but only exists since
// migration 026; last_used is the older date-only record, so it is the fallback and is
// shown without a time. Null for a widget that has never been used.
export const lastUsedOf = (w) => {
  if (w?.lastScanAt) return { at: w.lastScanAt, dateOnly: false };
  if (w?.last_used) return { at: w.last_used, dateOnly: true };
  return null;
};

// The site it was last loaded on, from the embedding page's address. Null until a page
// outside this app has loaded it: built and never embedded, or embedded on a page that
// sends no referrer.
export const embedOf = (w) => (w?.embedHost ? { host: w.embedHost, lastSeenAt: w.embedLastSeenAt || null } : null);
